var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',[_c('use',{attrs:{"xlink:href":require('@/assets/img/ui-graphics.svg') + _vm.iconID}})])}
var staticRenderFns = []

export { render, staticRenderFns }